import { render, staticRenderFns } from "./page-ad-card.vue?vue&type=template&id=0af9678a&"
import script from "./page-ad-card.vue?vue&type=script&lang=js&"
export * from "./page-ad-card.vue?vue&type=script&lang=js&"
import style0 from "./page-ad-card.vue?vue&type=style&index=0&id=0af9678a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports